/* global BigInt */

import KJUR from 'jsrsasign';
import forge from 'node-forge';
import { Result } from '../../src/services/clasesFirma';

import CryptoJS from 'crypto-js';
import ASN1 from '../../src/services/sat/asn1/asn1.js';
import Base64 from '../../src/services/sat/asn1/base64.js';
import sjcl from '../../src/services/sat/sjcl/sjcl.js';

let ASN1HEX = KJUR.ASN1HEX;
let RSAKey = KJUR.RSAKey;

export let messageeFirma = '';
export let PKCS7creadoeFirma = '';
export let extFileUploadeFirma = '';

let strCertificate = null;
export let strCerPem = null;
let strPrivateKey = null;

export function SelectFileSigneFirma(ctrlFile) {
  try {
    var file = ctrlFile;

    if (file != null) {
      let archivo = file.name;
      extFileUploadeFirma = archivo.split('.')[1];
    }

    var fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);

    return new Promise((resolve, reject) => {
      fileReader.onload = (e) => {
        var bufferFile = e.target.result;
        messageeFirma = ConvertToHex(bufferFile);
        if (messageeFirma != '') {
          resolve(true);
        }
        resolve(false);
      };
    });
  } catch (error) {
    console.error(error);
  }
}

export function SelectKEY(keyFile) {
  try {
    if (keyFile != null) {
      var file = keyFile;

      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      return new Promise((resolve, reject) => {
        fileReader.onload = (e) => {
          var bufferFile = e.target.result;
          strPrivateKey = bufferFile.split('base64,')[1];
          if (strPrivateKey != '') {
            return true;
          }
          return false;
        };
      });
    }
  } catch (error) {
    console.error(error);
  }
}

export function SelectCER(cerFile) {
  try {
    if (cerFile != null) {
      var file = cerFile;

      var fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      return new Promise((resolve, reject) => {
        fileReader.onload = (e) => {
          var bytes = new Uint8Array(fileReader.result);
          var binary = '';
          for (var i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var certHex = rstrtohex(binary);
          strCertificate = forge.util.encode64(forge.util.hexToBytes(certHex));
          var a = KJUR;
          strCerPem = KJUR.asn1.ASN1Util.getPEMStringFromHex(certHex, 'CERTIFICATE');
          if (messageeFirma != '') {
            resolve(true);
          }
          resolve(false);
        };
      });
    }
  } catch (error) {
    console.error(error);
  }
}

export function validateKeyPairs(strPass, fCallback) {
  var oResult = Result;
  if (strCertificate != null) {
    if (strPrivateKey != null) {
      var oResult = Result;
      if (typeof strPass != 'undefined') {
        if (strCerPem != null && strPrivateKey != null) {
          var certificate = new X509();
          certificate.readCertPEM(strCerPem);
          var certModule = certificate.subjectPublicKeyRSA.n;
          try {
            var privateKeyDecoded = ASN1.decode(Base64.unarmor(strPrivateKey));
            var privateKeyHex = obtieneLlavePrivada(privateKeyDecoded.toHexString(), strPass);
            var privateKeyB64 = hexToBase64(privateKeyHex);
            var rsakey = getKeyFromPlainPrivatePKCS8Hex(privateKeyHex);
            var moduloPrivada = rsakey.n;
          } catch (e) {
            console.error(e);

            if (e.indexOf('PKCS8 private key(code:001)') != -1) {
              oResult.state = -97;
              oResult.description =
                'La contraseña para acceder a la llave privada no es correcta, intente de nuevo.';
            } else {
              oResult.state = -95;
              oResult.description = 'Error: ' + e;
            }
            if (typeof fCallback != 'undefined') {
              fCallback(oResult);
            }
            return;
          }
          if (typeof moduloPrivada != 'undefined') {
            if (certModule.equals(moduloPrivada)) {
              oResult.privateKey = KJUR.asn1.ASN1Util.getPEMStringFromHex(
                privateKeyHex,
                'PRIVATE KEY'
              );
              oResult.state = 0;
              oResult.description = 'La verificación del par de llaves ha sido satisfactoria';
            } else {
              oResult.state = -99;
              oResult.description =
                'El certificado no corresponde con la llave privada proporcionada';
            }
          } else {
            oResult.state = -98;
            oResult.description = 'No se ha podido entender la llave privada';
          }
        }
      }
      if (typeof fCallback != 'undefined') {
        fCallback(oResult);
      }
    }
  }
}

export function FirmarEfirma(PrivateKeyPem) {
  try {
    return new Promise((resolve, reject) => {
      PrivateKeyPem = PrivateKeyPem.replace(/\r\n/g, '\n');
      strCerPem = strCerPem.replace(/\r\n/g, '\n');
      PKCS7creadoeFirma = CreatePKCS7(strCerPem, PrivateKeyPem, messageeFirma);

      if (PKCS7creadoeFirma != '') {
        resolve(true);
      }
      resolve(false);
    });
  } catch (error) {
    console.error(error);
  }
}

export function CreatePKCS7(certPEM, privateKeyPEM, messageeFirma) {
  var param = {
    econtent: {
      type: 'data',
      content: { hex: messageeFirma },
    },
    certs: [certPEM],
    sinfos: [
      {
        id: { type: 'isssn', cert: certPEM },
        hashalg: 'sha256',
        sattrs: {
          array: [
            { attr: 'contentType', type: 'data' },
            { attr: 'signingTime' },
            { attr: 'messageDigest', hex: '00' },
          ],
        },
        sigalg: 'SHA256withRSA',
        signkey: privateKeyPEM,
      },
    ],
  };

  try {
    var signedData = KJUR.asn1.cms.CMSUtil.newSignedData(param);
    var hex = signedData.getContentInfoEncodedHex();
    var pem = KJUR.asn1.ASN1Util.getPEMStringFromHex(hex, 'CMS');
    var pkcs7 = RemoveCMSHeader(pem);

    return pkcs7;
  } catch (error) {
    console.error(error);
  }
}

export function RemoveCMSHeader(cms) {
  var pkcs7 = '';
  try {
    pkcs7 = cms
      .replace('-----END CMS-----', '')
      .replace('-----BEGIN CMS-----', '')
      .replace(/(\r\n|\n|\r)/gm, '');
  } catch (error) {
    console.error(error);
  }
  return pkcs7;
}

export function ConvertToHex(arrayBuffer) {
  const buff = new Uint8Array(arrayBuffer);
  const hexOctets = [];

  for (let i = 0; i < buff.length; ++i) hexOctets.push(byteToHex[buff[i]]);

  return hexOctets.join('');
}

const byteToHex = [];

for (let n = 0; n <= 0xff; ++n) {
  const hexOctet = n.toString(16).padStart(2, '0');
  byteToHex.push(hexOctet);
}

export function hexToBase64(hex) {
  var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  if (typeof hex == 'undefined') return;
  var bytes = [];
  for (var i = 0, c = 0; c < hex.length; c += 2) {
    bytes.push(parseInt(hex.substr(c, 2), 16));
  }

  for (var base64 = [], i = 0; i < bytes.length; i += 3) {
    var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 <= bytes.length * 8)
        base64.push(base64map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
      else base64.push('=');
    }
  }
  return base64.join('');
}

export function rstrtohex(s) {
  var result = '';
  for (var i = 0; i < s.length; i++) {
    result += ('0' + s.charCodeAt(i).toString(16)).slice(-2);
  }
  return result;
}

function b64tohex(str) {
  const raw = atob(str);
  let result = '';
  for (let i = 0; i < raw.length; i++) {
    const hex = raw.charCodeAt(i).toString(16);
    result += hex.length === 2 ? hex : '0' + hex;
  }
  return result;
}

// LIBRARY X509
/*! x509-1.1.6.js (c) 2012-2015 Kenji Urushima | kjur.github.com/jsrsasign/license
 */
/*
 * x509.js - X509 class to read subject public key from certificate.
 *
 * Copyright (c) 2010-2015 Kenji Urushima (kenji.urushima@gmail.com)
 *
 * This software is licensed under the terms of the MIT License.
 * http://kjur.github.com/jsrsasign/license
 *
 * The above copyright and license notice shall be
 * included in all copies or substantial portions of the Software.
 */

/**
 * @fileOverview
 * @name x509-1.1.js
 * @author Kenji Urushima kenji.urushima@gmail.com
 * @version x509 1.1.6 (2015-May-20)
 * @since jsrsasign 1.x.x
 * @license <a href="http://kjur.github.io/jsrsasign/license/">MIT License</a>
 */

/*
 * Depends:
 *   base64.js
 *   rsa.js
 *   asn1hex.js
 */

/**
 * X.509 certificate class.<br/>
 * @class X.509 certificate class
 * @property {RSAKey} subjectPublicKeyRSA Tom Wu's RSAKey object
 * @property {String} subjectPublicKeyRSA_hN hexadecimal string for modulus of RSA public key
 * @property {String} subjectPublicKeyRSA_hE hexadecimal string for public exponent of RSA public key
 * @property {String} hex hexacedimal string for X.509 certificate.
 * @author Kenji Urushima
 * @version 1.0.1 (08 May 2012)
 * @see <a href="http://kjur.github.com/jsrsasigns/">'jwrsasign'(RSA Sign JavaScript Library) home page http://kjur.github.com/jsrsasign/</a>
 */
function X509() {
  this.subjectPublicKeyRSA = null;
  this.subjectPublicKeyRSA_hN = null;
  this.subjectPublicKeyRSA_hE = null;
  this.hex = null;

  // ===== read certificate public key ==========================

  // ===== read certificate =====================================
  /**
   * read PEM formatted X.509 certificate from string.<br/>
   * @name readCertPEM
   * @memberOf X509#
   * @function
   * @param {String} sCertPEM string for PEM formatted X.509 certificate
   */
  this.readCertPEM = function (sCertPEM) {
    var hCert = X509.pemToHex(sCertPEM);
    var a = X509.getPublicKeyHexArrayFromCertHex(hCert);
    var rsa = new RSAKey();
    rsa.setPublic(a[0], a[1]);
    this.subjectPublicKeyRSA = rsa;
    this.subjectPublicKeyRSA_hN = a[0];
    this.subjectPublicKeyRSA_hE = a[1];
    this.hex = hCert;
  };
}

X509.pemToBase64 = function (sCertPEM) {
  var s = sCertPEM;
  s = s.replace('-----BEGIN CERTIFICATE-----', '');
  s = s.replace('-----END CERTIFICATE-----', '');
  s = s.replace(/[ \n]+/g, '');
  return s;
};

X509.pemToHex = function (sCertPEM) {
  var b64Cert = X509.pemToBase64(sCertPEM);
  var hCert = b64tohex(b64Cert);
  return hCert;
};

// NOTE: Without BITSTRING encapsulation.
X509.getSubjectPublicKeyPosFromCertHex = function (hCert) {
  var pInfo = X509.getSubjectPublicKeyInfoPosFromCertHex(hCert);
  if (pInfo == -1) return -1;
  var a = ASN1HEX.getChildIdx(hCert, pInfo);
  if (a.length != 2) return -1;
  var pBitString = a[1];
  if (hCert.substring(pBitString, pBitString + 2) != '03') return -1;
  var pBitStringV = ASN1HEX.getVidx(hCert, pBitString);
  if (hCert.substring(pBitStringV, pBitStringV + 2) != '00') return -1;
  return pBitStringV + 2;
};

// NOTE: privateKeyUsagePeriod field of X509v2 not supported.
// NOTE: v1 and v3 supported
X509.getSubjectPublicKeyInfoPosFromCertHex = function (hCert) {
  // function ok
  var pTbsCert = ASN1HEX.getVidx(hCert, 0);
  var a = ASN1HEX.getChildIdx(hCert, pTbsCert);
  if (a.length < 1) return -1;
  if (hCert.substring(a[0], a[0] + 10) == 'a003020102') {
    // v3
    if (a.length < 6) return -1;
    return a[6];
  } else {
    if (a.length < 5) return -1;
    return a[5];
  }
};

X509.getPublicKeyHexArrayFromCertHex = function (hCert) {
  var p = X509.getSubjectPublicKeyPosFromCertHex(hCert);
  var a = ASN1HEX.getChildIdx(hCert, p);
  if (a.length != 2) return [];
  var hN = ASN1HEX.getV(hCert, a[0]);
  var hE = ASN1HEX.getV(hCert, a[1]);
  if (hN != null && hE != null) {
    return [hN, hE];
  } else {
    return [];
  }
};

function getKeyFromPlainPrivatePKCS8Hex(prvKeyHex) {
  var p8 = parsePlainPrivatePKCS8Hex(prvKeyHex);
  if (p8.algoid == '2a864886f70d010101') {
    parsePrivateRawRSAKeyHexAtObj(prvKeyHex, p8);
    var k = p8.key;
    var key = new RSAKey();
    key.setPrivateEx(k.n, k.e, k.d, k.p, k.q, k.dp, k.dq, k.co);
    return key;
  } else if (p8.algoid == '2a8648ce3d0201') {
    this.parsePrivateRawECKeyHexAtObj(prvKeyHex, p8);
    if (KJUR.crypto.OID.oidhex2name[p8.algparam] === undefined)
      throw 'KJUR.crypto.OID.oidhex2name undefined: ' + p8.algparam;
    var curveName = KJUR.crypto.OID.oidhex2name[p8.algparam];
    var key = new KJUR.crypto.ECDSA({
      curve: curveName,
    });
    key.setPublicKeyHex(p8.pubkey);
    key.setPrivateKeyHex(p8.key);
    key.isPublic = false;
    return key;
  } else if (p8.algoid == '2a8648ce380401') {
    var hP = ASN1HEX.getVbyList(prvKeyHex, 0, [1, 1, 0], '02');
    var hQ = ASN1HEX.getVbyList(prvKeyHex, 0, [1, 1, 1], '02');
    var hG = ASN1HEX.getVbyList(prvKeyHex, 0, [1, 1, 2], '02');
    var hX = ASN1HEX.getVbyList(prvKeyHex, 0, [2, 0], '02');
    var biP = new BigInt(hP, 16);
    var biQ = new BigInt(hQ, 16);
    var biG = new BigInt(hG, 16);
    var biX = new BigInt(hX, 16);
    var key = new KJUR.crypto.DSA();
    key.setPrivate(biP, biQ, biG, null, biX);
    return key;
  } else {
    throw 'unsupported private key algorithm';
  }
}
function parsePrivateRawRSAKeyHexAtObj(pkcs8PrvHex, info) {
  var keyIdx = info.keyidx;
  if (pkcs8PrvHex.substr(keyIdx, 2) != '30') throw 'malformed RSA private key(code:001)';
  var a1 = ASN1HEX.getChildIdx(pkcs8PrvHex, keyIdx);
  if (a1.length != 9) throw 'malformed RSA private key(code:002)';
  info.key = {};
  info.key.n = ASN1HEX.getV(pkcs8PrvHex, a1[1]);
  info.key.e = ASN1HEX.getV(pkcs8PrvHex, a1[2]);
  info.key.d = ASN1HEX.getV(pkcs8PrvHex, a1[3]);
  info.key.p = ASN1HEX.getV(pkcs8PrvHex, a1[4]);
  info.key.q = ASN1HEX.getV(pkcs8PrvHex, a1[5]);
  info.key.dp = ASN1HEX.getV(pkcs8PrvHex, a1[6]);
  info.key.dq = ASN1HEX.getV(pkcs8PrvHex, a1[7]);
  info.key.co = ASN1HEX.getV(pkcs8PrvHex, a1[8]);
}

function obtenLlaveDerivada(info, passcode) {
  var pbkdf2Iter = info.pbkdf2Iter;
  var pbkdf2KeyWS;
  var hmacSHA1 = function (key) {
    var hasher = new sjcl.misc.hmac(key, sjcl.hash.sha1);
    this.encrypt = function () {
      return hasher.encrypt.apply(hasher, arguments);
    };
  };
  var sjclSalt = sjcl.codec.hex.toBits(info.pbkdf2Salt);
  if (info.encryptionSchemeAlg == 'DES' || info.encryptionSchemeAlg == 'TripleDES') {
    pbkdf2KeyWS = sjcl.misc.pbkdf2(passcode, sjclSalt, pbkdf2Iter, 192, hmacSHA1);
  } else if (info.encryptionSchemeAlg == 'AES-256') {
    pbkdf2KeyWS = sjcl.misc.pbkdf2(passcode, sjclSalt, pbkdf2Iter, 256, hmacSHA1);
  } else if (info.encryptionSchemeAlg == 'AES-128') {
    pbkdf2KeyWS = sjcl.misc.pbkdf2(passcode, sjclSalt, pbkdf2Iter, 128, hmacSHA1);
  } else if (info.encryptionSchemeAlg == 'AES-192') {
    pbkdf2KeyWS = sjcl.misc.pbkdf2(passcode, sjclSalt, pbkdf2Iter, 192, hmacSHA1);
  } else if (info.encryptionSchemeAlg == 'RC2') {
    pbkdf2KeyWS = sjcl.misc.pbkdf2(passcode, sjclSalt, pbkdf2Iter, info.tamLlave, hmacSHA1);
  } else throw 'Algoritmo no soportado';
  var pbkdf2KeyHex = sjcl.codec.hex.fromBits(pbkdf2KeyWS);
  return pbkdf2KeyHex;
}
function obtieneLlavePrivada(pkcs8DER, passcode) {
  var decWS;
  var info = obtieneInfoPKCS8(pkcs8DER);
  var pbkdf2KeyHex = obtenLlaveDerivada(info, passcode);
  var encrypted = {};
  encrypted.ciphertext = CryptoJS.enc.Hex.parse(info.ciphertext);
  var pbkdf2KeyWS = CryptoJS.enc.Hex.parse(pbkdf2KeyHex);
  var IVWS = CryptoJS.enc.Hex.parse(info.encryptionSchemeIV);
  if (info.encryptionSchemeAlg === 'TripleDES')
    decWS = CryptoJS.TripleDES.decrypt(encrypted, pbkdf2KeyWS, {
      iv: IVWS,
    });
  else if (info.encryptionSchemeAlg === 'DES')
    decWS = CryptoJS.DES.decrypt(encrypted, pbkdf2KeyWS, {
      iv: IVWS,
    });
  else if (
    info.encryptionSchemeAlg === 'AES-128' ||
    info.encryptionSchemeAlg === 'AES-192' ||
    info.encryptionSchemeAlg === 'AES-256'
  )
    decWS = CryptoJS.AES.decrypt(encrypted, pbkdf2KeyWS, {
      iv: IVWS,
    });
  else if (info.encryptionSchemeAlg === 'RC2') {
    var effectiveKey = CryptoJS.enc.Hex.parse(info.effectiveKey);
    decWS = CryptoJS.RC2.decrypt(encrypted, pbkdf2KeyWS, {
      effectiveKeyBits: info.effectiveKey,
      iv: IVWS,
    });
    var decHex = CryptoJS.enc.Hex.stringify(decWS);
    decWS = CryptoJS.RC2.decrypt(encrypted, pbkdf2KeyWS, {
      effectiveKeyBits: effectiveKey,
      iv: IVWS,
    });
    var decHex = CryptoJS.enc.Hex.stringify(decWS);
    decWS = CryptoJS.RC2.decrypt(encrypted, pbkdf2KeyWS, {
      iv: IVWS,
    });
    var decHex = CryptoJS.enc.Hex.stringify(decWS);
    decWS = CryptoJS.RC2.decrypt(encrypted, pbkdf2KeyWS, {
      effectiveKeyBits: 40,
      iv: IVWS,
    });
    var decHex = CryptoJS.enc.Hex.stringify(decWS);
    decWS = CryptoJS.RC2.decrypt(encrypted, pbkdf2KeyWS, {
      effectiveKeyBits: 160,
      iv: IVWS,
    });
    var decHex = CryptoJS.enc.Hex.stringify(decWS);
    decWS = CryptoJS.RC2.decrypt(encrypted, pbkdf2KeyWS, {
      effectiveKeyBits: 120,
      iv: IVWS,
    });
    var decHex = CryptoJS.enc.Hex.stringify(decWS);
    decWS = CryptoJS.RC2.decrypt(encrypted, pbkdf2KeyWS, {
      effectiveKeyBits: 58,
      iv: IVWS,
    });
    var decHex = CryptoJS.enc.Hex.stringify(decWS);
    decWS = CryptoJS.RC2.decrypt(encrypted, pbkdf2KeyWS, {
      effectiveKeyBits: effectiveKey,
    });
  }
  var decHex = CryptoJS.enc.Hex.stringify(decWS);
  return decHex;
}
function obtieneInfoPKCS8(sHEX) {
  var info = {};
  var a0 = ASN1HEX.getChildIdx(sHEX, 0);
  if (a0.length != 2) throw 'malformed format: SEQUENCE(0).items != 2: ' + a0.length;
  info.ciphertext = ASN1HEX.getV(sHEX, a0[1]);
  var a0_0 = ASN1HEX.getChildIdx(sHEX, a0[0]);
  if (a0_0.length != 2) throw 'malformed format: SEQUENCE(0.0).items != 2: ' + a0_0.length;
  var x = ASN1HEX.getV(sHEX, a0_0[0]);
  if (ASN1HEX.getV(sHEX, a0_0[0]) != '2A864886F70D01050D') throw 'this only supports pkcs5PBES2';
  var a0_0_1 = ASN1HEX.getChildIdx(sHEX, a0_0[1]);
  if (a0_0.length != 2) throw 'malformed format: SEQUENCE(0.0.1).items != 2: ' + a0_0_1.length;
  var a0_0_1_0 = ASN1HEX.getChildIdx(sHEX, a0_0_1[0]);
  if (a0_0_1_0.length != 2)
    throw 'malformed format: SEQUENCE(0.0.1.0).items != 2: ' + a0_0_1_0.length;
  var a0_0_1_1 = ASN1HEX.getChildIdx(sHEX, a0_0_1[1]);
  if (a0_0_1_1.length != 2)
    throw 'malformed format: SEQUENCE(0.0.1.1).items != 2: ' + a0_0_1_1.length;
  var algoritmo = ASN1HEX.getV(sHEX, a0_0_1_1[0]);
  if (algoritmo === '2A864886F70D0307' || algoritmo === '3ECE45092C62A8B9')
    info.encryptionSchemeAlg = 'TripleDES';
  else if (algoritmo === '2B0E030207') info.encryptionSchemeAlg = 'DES';
  else if (algoritmo === '608648016503040116') info.encryptionSchemeAlg = 'AES-192';
  else if (algoritmo === '608648016503040102') info.encryptionSchemeAlg = 'AES-128';
  else if (algoritmo === '60864801650304012A') info.encryptionSchemeAlg = 'AES-256';
  else if (algoritmo === '2A864886F70D0302') info.encryptionSchemeAlg = 'RC2';
  else throw 'Algortimo no soportado ' + algoritmo;
  if (info.encryptionSchemeAlg !== 'RC2') info.encryptionSchemeIV = ASN1HEX.getV(sHEX, a0_0_1_1[1]);
  else {
    var a0_0_1_1_1 = ASN1HEX.getChildIdx(sHEX, a0_0_1_1[1]);
    info.effectiveKey = ASN1HEX.getV(sHEX, a0_0_1_1_1[0]);
    info.encryptionSchemeIV = ASN1HEX.getV(sHEX, a0_0_1_1_1[1]);
  }
  var x1 = ASN1HEX.getV(sHEX, a0_0_1_0[0]);
  if (ASN1HEX.getV(sHEX, a0_0_1_0[0]) != '2A864886F70D01050C')
    throw 'this only supports pkcs5PBKDF2';
  var a0_0_1_0_1 = ASN1HEX.getChildIdx(sHEX, a0_0_1_0[1]);
  if (a0_0_1_0_1.length < 2)
    throw 'malformed format: SEQUENCE(0.0.1.0.1).items < 2: ' + a0_0_1_0_1.length;
  info.pbkdf2Salt = ASN1HEX.getV(sHEX, a0_0_1_0_1[0]);
  var iterNumHex = ASN1HEX.getV(sHEX, a0_0_1_0_1[1]);
  try {
    info.pbkdf2Iter = parseInt(iterNumHex, 16);
  } catch (ex) {
    throw 'malformed format pbkdf2Iter: ' + iterNumHex;
  }
  if (info.encryptionSchemeAlg === 'RC2') {
    var tamLlave_ = ASN1HEX.getV(sHEX, a0_0_1_0_1[2]);
    try {
      info.tamLlave = parseInt(tamLlave_, 16);
    } catch (ex) {
      throw 'malformed format tamLlave: ' + tamLlave_;
    }
  }
  return info;
}
function parsePlainPrivatePKCS8Hex(pkcs8PrvHex) {
  var result = {};
  result.algparam = null;
  if (pkcs8PrvHex.substr(0, 2) != '30') throw 'malformed plain PKCS8 private key(code:001)';
  var a1 = ASN1HEX.getChildIdx(pkcs8PrvHex, 0);
  if (a1.length != 3) throw 'malformed plain PKCS8 private key(code:002)';
  if (pkcs8PrvHex.substr(a1[1], 2) != '30') throw 'malformed PKCS8 private key(code:003)';
  var a2 = ASN1HEX.getChildIdx(pkcs8PrvHex, a1[1]);
  if (a2.length != 2) throw 'malformed PKCS8 private key(code:004)';
  if (pkcs8PrvHex.substr(a2[0], 2) != '06') throw 'malformed PKCS8 private key(code:005)';
  result.algoid = ASN1HEX.getV(pkcs8PrvHex, a2[0]);
  if (pkcs8PrvHex.substr(a2[1], 2) == '06') {
    result.algparam = ASN1HEX.getV(pkcs8PrvHex, a2[1]);
  }
  if (pkcs8PrvHex.substr(a1[2], 2) != '04') throw 'malformed PKCS8 private key(code:006)';
  result.keyidx = ASN1HEX.getVidx(pkcs8PrvHex, a1[2]);
  return result;
}
